import React from 'react';
import { Container, Button } from '@infoods/lifebase-ui';

import { observer } from 'mobx-react';

import { angularizeWithProviders } from '../../../shared/providers';
import { DetailedRevenue } from '../../containers/DetailedRevenue/DetailedRevenue';
import { loggedInUserDataStore } from '../../../shared/stores/loggedInUserDataStore';
import { solutionsStore } from '../../../shared/stores/solutionsStore';
import { UnavailableSolutionError } from '../../../shared/containers/NgzUnavailableSolutionError/NgzUnavailableSolutionError';
import { ErrorState } from '../../../shared/components/ErrorState/ErrorState';
import { goToHomePage } from '../../../shared/utils/angularUtils';

const NgzDetailedRevenuePage = observer(() => {
  const { getEntityId, loggedInUser, billingType } = loggedInUserDataStore;
  const { activeSolution, activeSolutionFlags } = solutionsStore;

  const entityId = getEntityId();

  if (!loggedInUser) {
    return null;
  }

  if (!activeSolutionFlags.NUTRITION) {
    return <UnavailableSolutionError activeSolution={activeSolution} />;
  }

  if (billingType.SELF_BILLING) {
    return (
      <ErrorState
        title="Detailed Revenue is not available for self-billing"
        description="Detailed Revenue can only be viewed for entities on automated billing."
      >
        <Button variant="contained" onClick={goToHomePage}>
          Return to the Main Page
        </Button>
      </ErrorState>
    );
  }

  return (
    <Container>
      <DetailedRevenue
        entityId={entityId}
        entityRegistrationDate={loggedInUser.registrationDate}
      />
    </Container>
  );
});

angularizeWithProviders(NgzDetailedRevenuePage, 'ngzDetailedRevenuePage', {});

export { NgzDetailedRevenuePage };
